import { Donation } from "../../types"
import { Icon } from "source/shared/components/Icon/Icon"
import { css } from "@emotion/react"
import { PaymentMethodIcon } from "source/payments/components/icons/PaymentMethodIcon"

export default function PaymentMethodPresenter({
  donation,
}: {
  donation: Donation
}) {
  const nonCardPresenter = {
    ach: {
      symbol: "churchCenter#bank",
      text: `${donation.payment_brand ?? "Bank Transfer"} ${donation.payment_last4 ? `...${donation.payment_last4}` : ""}`,
    },
    cash: {
      symbol: "general#bill",
      text: "Cash",
    },
    check: {
      symbol: "churchCenter#bank-check",
      text: "Check",
    },
  }

  return (
    <div className="d-f ai-c">
      {donation.payment_method !== "card" ? (
        <>
          <Icon
            symbol={nonCardPresenter[donation.payment_method].symbol}
            css={css`
              fill: var(--color-tint2);
            `}
          />
          <span className="payment-method-badge__meta">
            {nonCardPresenter[donation.payment_method].text}
          </span>
        </>
      ) : (
        <>
          <PaymentMethodIcon
            brand={donation.payment_brand}
            isCard={donation.payment_method === "card"}
          />
          <span className="payment-method-badge__meta">
            {donation.payment_brand ?? "Card"}{" "}
            {donation.payment_last4 ? `...${donation.payment_last4}` : ""}
          </span>
        </>
      )}
    </div>
  )
}
